export default __webpack_public_path__ + "static/media/loungewear.a7e935f2.jpg";